import React, { useState, useEffect, useRef } from 'react'
import { DatasetSync, getUserbyID } from '../services/data'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import validateJSON from './jsonvalidation'
import { useSubscription } from '../context/subscriptionprovider'
import Cookies from 'js-cookie'
import { useAuth } from '../context/logincontext'

const ShopifyCallback = () => {
  const navigate = useNavigate()
  const [toastShown, setToastShown] = useState(false)
  const showprogressRef = useRef(false)
  const subscriptionContext = useSubscription()
  const { userdata, login } = useAuth() // Added login function from useAuth

  // Safe access to refreshSubscription
  const refreshSubscription =
    subscriptionContext?.refreshSubscription || (() => {})

  const showToast = () => {
    if (!toastShown) {
      toast.success('Switching to Owner Account', {
        position: 'bottom-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: 'light',
        onClose: () => handleRedirect()
      })
      setToastShown(true)
    }
  }

  const handleRedirect = async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const storeId = urlParams.get('store_id')
    const onboarding = urlParams.get('onboarding')

    if (!storeId) return // safety guard

    if (onboarding === 'true') {
      refreshSubscription()
      localStorage.setItem('chatbot', 'shopify')
      toast.warn('Redirecting to subscription page...', {
        position: 'bottom-center',
        autoClose: 3000
      })

      setTimeout(() => {
        localStorage.removeItem('onboarding')
        window.dispatchEvent(
          new CustomEvent('storeSwitchedtrigger', { detail: true })
        )
        window.dispatchEvent(new CustomEvent('storeChanger', { detail: true }))
        navigate(`/store/${storeId}/subscription`)
      }, 3000)
    } else {
      setTimeout(() => {
        refreshSubscription()
        localStorage.setItem('chatbot', 'shopify')
        window.dispatchEvent(
          new CustomEvent('storeSwitchedtrigger', { detail: true })
        )
        window.dispatchEvent(new CustomEvent('storeChanger', { detail: true }))
        navigate(`/store/${storeId}/training`)
      }, 3000)
    }
  }

  const handlePageLoad = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const storeId = urlParams.get('store_id')
    const onboarding = urlParams.get('onboarding')
    const token = urlParams.get('token')
    const user_id = urlParams.get('user_id')

    if (storeId && token && user_id) {
      localStorage.setItem('onboarding', onboarding)

      const getuser = async () => {
        const existsUser = validateJSON(userdata)
        if (existsUser?.id !== parseInt(user_id)) {
          const res = await getUserbyID(user_id)

          // Use the login function from AuthContext instead of directly setting localStorage
          if (res.data && res.data[0]) {
            login(res.data[0]) // This will properly set the user in the auth context
            localStorage.setItem('owner_account', false)
          }
        } else {
          localStorage.setItem('owner_account', true)
          handleRedirect()
        }
      }

      // getuser()
    }
  }

  useEffect(() => {
    showToast()
    handlePageLoad()
  }, [])

  return <ToastContainer />
}

export default ShopifyCallback
